import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
    selector: '[longPress]',
    standalone: false,
})
export class LongPressDirective {
  @Output() longPress = new EventEmitter<TouchEvent>();

  private pressTimer: any;

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent): void {
    this.pressTimer = setTimeout(() => {
      this.longPress.emit(event);
    }, 600);
  }

  @HostListener('touchend') onTouchEnd() {
    clearTimeout(this.pressTimer);
  }

  @HostListener('touchmove') onTouchMove() {
    clearTimeout(this.pressTimer);
  }
}
